import type { Theme } from "../store/useStore";

/**
 * Kommunen-CI in den Diagrammen (Issue #127). KommunenAkzent legt die Farbe
 * der aktiven Kommune hier ab; chartColors() und die Farbrampe nehmen sie als
 * Akzent. Eigenes, winziges Modul mit Absicht: KommunenAkzent gehört zum
 * Einstieg, components/charts.tsx nicht — ein Import von dort zöge die
 * Diagramme (und den Pfad zu echarts) in den Einstiegs-Chunk.
 */
let akzent: { hell: string; dunkel: string } | null = null;

export function setzeChartAkzent(f: { hell: string; dunkel: string } | null): void {
  akzent = f;
}

export function chartAkzentFarbe(theme: Theme): string | null {
  return akzent ? (theme === "dark" ? akzent.dunkel : akzent.hell) : null;
}
